// extracted by mini-css-extract-plugin
export default {"success":"Alert_success__8UUjP","error":"Alert_error__bLWPL","img_mssg":"Alert_img_mssg__FyuxB"};